import React from "react";
import { three } from "./data-p";
import { motion } from "framer-motion";
import { FaInfoCircle } from "react-icons/all";

const Latest = () => {
  return (
    <div className="l-prs-c">
      <div className="l-hr">
        <h1>Recent Projects</h1>
        {/* <p>These are some of the last projects i have created in React JS.</p> */}
      </div>
      <div className="l-prs">
        {three.map((th, index) => {
          const { img, name, url, varID, note } = th;
          return (
            <motion.a
              href={url}
              key={index}
              className="l-pr lts"
              style={{ background: `url(/images-p/${img})` }}
              initial={{ opacity: 0, y: -15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                delay: varID,
                duration: 0.7,
                ease: "easeInOut",
              }}
            >
              <div className="l-pr-txt">
                <h3>{name}</h3>
                {note ? (
                  <p>
                    <FaInfoCircle /> This project is not yet finished
                  </p>
                ) : (
                  ""
                )}
              </div>
            </motion.a>
          );
        })}
      </div>
    </div>
  );
};

export default Latest;
